/**
 * Copyright Mántum All Rights Reserved.
 */
import Component from './component';
import Validator from '../validator';
import debug from 'debug';
import useEmpty from '../../../hooks/useEmpty';
import { EVENT_CLEAR, ACTION_VALUE, useGroupDispatch } from '../../group';
import { forwardRef, useImperativeHandle, useRef } from 'react';

import type { Detail } from '@mantum/kanela';
import type { PropTypes } from './component';

const logger = debug('kanela');

export default forwardRef<Detail<unknown>, PropTypes>(
    function Textarea(props, ref) {
        // prettier-ignore
        const { 
        error = false,
        name,
        optional = true
    } = props;

        const dispatch = useGroupDispatch();

        const empty = useEmpty(optional);
        const inputRef = useRef<HTMLTextAreaElement>(null);

        useImperativeHandle(
            ref,
            () => {
                return {
                    name,
                    validable: !optional,
                    clear() {
                        empty.clear();
                        if (name) {
                            logger('dispatch field cleaning "%s"', name);
                            dispatch({
                                type: EVENT_CLEAR,
                                content: [
                                    {
                                        action: ACTION_VALUE,
                                        target: name
                                    }
                                ]
                            });
                        }
                    },
                    validate() {
                        return empty.validate(inputRef.current?.value);
                    },
                    value() {
                        return inputRef.current?.value;
                    }
                };
            },
            [name, optional, empty, dispatch]
        );

        const handleBlur = (event: React.FocusEvent<HTMLTextAreaElement>) => {
            empty.validate(event.target.value);

            if (props.onBlur) {
                props.onBlur(event);
            }
        };

        return (
            <Validator
                error={empty.value || error}
                message={props.validation?.message}
                type='textarea'
            >
                <Component
                    {...props}
                    error={empty.value || error}
                    onBlur={handleBlur}
                    onChange={props.onChange}
                    ref={inputRef}
                />
            </Validator>
        );
    }
);
